import * as React from 'react';
import { btnStyle } from '../forms/styles/button';
import { COLORS } from '../globalStyle/colors';
import { Str } from '../localization/translationKeys';
import { faEnvelope, faWrench } from '@fortawesome/free-solid-svg-icons';
import { css } from '@emotion/core';
import { Z_INDEX } from '../globalStyle/zIndex';
import MobileToolbar from '../layout/mobile/MobileToolbar';
import MobileToolbarBtn from '../localization/MobileToolbarBtn';


const styles = {
  root:   css`
    justify-content: flex-end;
    width: 100vw;
    height: 72px;
    position: fixed;
    bottom: 0;
    z-index: ${Z_INDEX.MOBILE_TOOLBAR};
    background-color: ${COLORS.WHITE};
  `,
  button: css`
    height: auto;
    line-height: 12px;
    font-size: 9px;
    border-radius: 0;
    flex-basis: 80px;
    border-color: transparent;
    & > span {
      overflow-wrap: break-spaces;
      text-transform: uppercase;
    }
  `,
};


type Props = {
  className?: string;

  disableCustomizeModalButton: boolean;
  disableSendApprovalButton: boolean;

  onClickCustomizeModalButton: () => void;
  onClickSendMsgButton: () => void;
}


/**
 * MobileRaterApprovalToolbar: a tool bar which houses the action buttons associated with the rater approval flow on
 * mobile screens.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const MobileRaterApprovalToolbar: React.FC<Props> = props => (
  <MobileToolbar className={props.className}>
    <MobileToolbarBtn
      css={[btnStyle.transparent(COLORS.DARK_GREY), styles.button]}
      str={Str.CustomizeEmail}
      icon={faWrench}
      onClick={props.onClickCustomizeModalButton}
      disabled={props.disableCustomizeModalButton}
    />
    <MobileToolbarBtn
      css={[btnStyle.primary(COLORS.GREEN), styles.button]}
      str={Str.SendApproval}
      icon={faEnvelope}
      onClick={props.onClickSendMsgButton}
      disabled={props.disableSendApprovalButton}
    />
  </MobileToolbar>
);

export default MobileRaterApprovalToolbar;
